import { createFileRoute } from '@tanstack/react-router'
import { CRT_ROUTES, toStaticData } from '../../../crt-route-config'

export const Route = createFileRoute('/_auth/_modules/crt/materials/insights/federal-excise')({
  staticData: toStaticData(CRT_ROUTES['/crt/materials/insights/federal-excise']),
  beforeLoad: async ({ context }) => {
    context.handleRoutePermissions(Route)
  },
})
